var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Month(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#E365B1",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E365B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 11.5C25.7722 11.5 27.6578 11.5 28.8294 12.7448C30.001 13.9896 30.001 15.9931 30.001 20C30.001 24.0069 30.001 26.0104 28.8294 27.2552C27.6578 28.5 25.7722 28.5 22.001 28.5L18.001 28.5C14.2297 28.5 12.3441 28.5 11.1725 27.2552C10.001 26.0104 10.001 24.0069 10.001 20C10.001 15.9931 10.001 13.9896 11.1726 12.7448C12.3441 11.5 14.2297 11.5 18.001 11.5L22.001 11.5Z",
    stroke: "#E365B1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.409 24.608C12.729 24.608 11.553 23.624 11.541 22.196H12.729C12.777 23.072 13.425 23.636 14.409 23.636C15.429 23.636 16.053 23.084 16.053 22.208C16.053 21.356 15.345 20.816 14.229 20.816H13.389V19.844H14.169C15.081 19.844 15.681 19.316 15.681 18.524C15.681 17.756 15.141 17.24 14.325 17.24C13.497 17.24 12.945 17.768 12.909 18.596H11.733C11.769 17.264 12.897 16.268 14.373 16.268C15.933 16.268 16.941 17.168 16.941 18.44C16.941 19.232 16.473 19.868 15.633 20.264C16.701 20.552 17.313 21.248 17.313 22.184C17.313 23.624 16.137 24.608 14.409 24.608ZM19.7036 24.5H18.4916V18.14H19.6196V19.196C20.0516 18.464 20.7356 18.02 21.6116 18.02C22.5476 18.02 23.2556 18.5 23.5436 19.34C23.9876 18.524 24.7196 18.02 25.6916 18.02C26.9996 18.02 27.8396 18.872 27.8396 20.384V24.5H26.6276V20.768C26.6276 19.712 26.1596 19.088 25.2716 19.088C24.4436 19.088 23.7716 19.784 23.7716 20.852V24.5H22.5596V20.768C22.5596 19.712 22.0916 19.088 21.2036 19.088C20.3636 19.088 19.7036 19.784 19.7036 20.852V24.5Z",
    fill: "#E365B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Month);
export default __webpack_public_path__ + "static/media/3month.9982e9ed12e1dfbbed2d21e741859162.svg";
export { ForwardRef as ReactComponent };